import type { DeviceNotificationPort } from '@Domain/Ports/Notification/DeviceNotificationPort';
import PortsContext from '@UI/Providers/PortsProvider/PortsContext';
import * as React from 'react';

function useDeviceNotificationPort(): DeviceNotificationPort {
	const context = React.useContext(PortsContext);

	if (context === null) {
		throw new Error('useDeviceNotificationPort doit être utilisé à l’intérieur d’un PortsProvider.');
	}

	return context.notification;
}

export default useDeviceNotificationPort;
